import React from 'react';
import { Link } from 'react-router-dom';
import { hasToken } from './services/authService';
import './ContactUsPage.css';
import './SupportPages.css';

const CONTACT_EMAIL = 'talentvibe@govcomsolutions.com';

function ContactUsPage() {
  const loggedIn = typeof hasToken === 'function' ? hasToken() : false;

  return (
    <div className="contact-page">
      <div className="glass-container contact-card">
        <p className="contact-eyebrow">TalentVibe</p>
        <h1 className="contact-title">Contact us</h1>
        <p className="contact-lead">
          Questions about TalentVibe, demos, or support? Email us or raise an in-app support
          ticket — we typically respond within one business day.
        </p>
        <a className="contact-email" href={`mailto:${CONTACT_EMAIL}`}>
          {CONTACT_EMAIL}
        </a>
        <p className="contact-hint">Click the address above to open your email app.</p>

        <div className="contact-cta-row">
          {loggedIn ? (
            <Link to="/support/new" className="support-btn">
              Raise a support ticket
            </Link>
          ) : (
            <Link to="/login?next=/support/new" className="support-btn">
              Sign in to raise a ticket
            </Link>
          )}
          {loggedIn && (
            <Link to="/support" className="support-btn secondary">
              My tickets
            </Link>
          )}
        </div>

        <Link to="/" className="contact-back">
          ← Back to home
        </Link>
      </div>
    </div>
  );
}

export default ContactUsPage;
